<div class="help wrapper" *ngIf="userDetailsWire">
    <div class="row">

        <!-- SSO Menu + Agent -->
        <!-- This code can be deleted when okta is live and seems stable -->
        <!-- we call oktaService.oktaInUse directly as if we only call it once in ngOnInit it wont run enough times to have the actual value -->
        <ul *ngIf="!oktaService.oktaInUse()" class="column small-12" id="SSO">

            <!-- Phone + online help center -->
            <li *ngIf="serviceLinks.contact">
                <a title="PhoneNumber" class="icon-phone" href="{{serviceLinks.contact}}">{{serviceLinks.contact}}</a>
            </li>
            <li *ngIf="serviceLinks.onlineHelp">
                <a title="OnlineHelp" class="icon-bubbles" href="{{serviceLinks.onlineHelp}}" target="_blank">{{
                        "ONLINE_HELP" | resource
                    }}</a>
            </li>

            <!-- SSO normal user -->
            <li *ngIf="!userDetailsWire.isAuthenticated && !userDetailsWire.isAgent && !agentPage">
                <a title="Login" class="icon-user" href="{{getLoginLink()}}">{{
                    "LOG_IN" | resource
                }}</a>
            </li>
            <li *ngIf="!userDetailsWire.isAuthenticated && !userDetailsWire.isAgent && !!agentPage">
                <a title="Register" class="icon-lock" href="{{getLoginLink()}}">{{
                    "REGISTER" | resource
                }}</a>
            </li>
            <li *ngIf="userDetailsWire.isAuthenticated && !userDetailsWire.isAgent && userDetailsWire.user">
                <a title="User" class="icon-user" routerLink="/amendment/bookings"
                    routerLinkActive="active">{{userDetailsWire.user.name ? userDetailsWire.user.name : ''}}
                    {{ userDetailsWire.user.name ? '|' : '' }}
                    {{ userDetailsWire.user.email }}</a>
            </li>

            <!-- Agent -->
            <li *ngIf="userDetailsWire.isAuthenticated && userDetailsWire.isAgent && userDetailsWire.agent">
                <a title="User" class="icon-user" routerLink="/agent/bookings"
                    routerLinkActive="active">{{userDetailsWire.agent.name}} | {{ userDetailsWire.agent.company }} |
                    {{ userDetailsWire.agent.reference }}</a>
            </li>
            <li *ngIf="userDetailsWire.isAuthenticated">
                <a title="Logout" class="icon-lock" href="{{getLogoutLink()}}">{{
                    "LOG_OUT" | resource
                }}</a>
            </li>
            <li *ngIf="userDetailsWire.isAuthenticated && userDetailsWire.isAgent">
                <a title="User" class="icon-plus" routerLink="/agent" routerLinkActive="active">{{
                        "START_NEW_RESERVATION" | resource
                    }}
                </a>
            </li>
        </ul>

        <!-- Okta menu + agent -->
        <!-- we call oktaService.oktaInUse directly as if we only call it once in ngOnInit it wont run enough times to have the actual value -->
        <ul *ngIf="oktaService.oktaInUse()" class="column small-12" id="OKTA">

            <!-- Phone + online help center -->
            <li *ngIf="serviceLinks.contact">
                <a title="PhoneNumber" class="icon-phone" href="{{serviceLinks.contact}}">{{serviceLinks.contact}}</a>
            </li>
            <li *ngIf="serviceLinks.onlineHelp">
                <a title="OnlineHelp" class="icon-bubbles" href="{{serviceLinks.onlineHelp}}" target="_blank">{{
                        "ONLINE_HELP" | resource
                    }}</a>
            </li>

            <!-- Okta -->
            <li *ngIf="user.value != null && !userDetailsWire.isAgent">
                <a title="User" class="icon-user" [attr.aria-disabled]="!oktaLoaded"
                    routerLink="/amendment/bookings">{{user.value}}</a>
            </li>
            <li *ngIf="user.value != null && !userDetailsWire.isAgent">
                <a title="Logout" class="icon-lock" [attr.aria-disabled]="!oktaLoaded"
                    (click)="oktaService.initiateLogout()">{{ 'LOG_OUT' | resource }}</a>
            </li>
            <li *ngIf="!user.value && !agentPage && !userDetailsWire.isAgent">
                <a title="Login/Create user" [attr.aria-disabled]="!oktaLoaded" class="icon-user"
                    (click)="oktaService.initiateLogin()">{{ 'ACCOUNT_LOGIN' | resource }} /
                    {{ 'ACCOUNT_REGISTER' | resource }}</a>
            </li>

            <!-- Agent -->
            <li *ngIf="username && userDetailsWire.isAgent && userDetailsWire.agent">
                <a title="User" class="icon-user" routerLink="/agent/bookings"
                    routerLinkActive="active">{{userDetailsWire.agent.name}} | {{ userDetailsWire.agent.company }} |
                    {{ userDetailsWire.agent.reference }}</a>
            </li>
            <li *ngIf="!username && (userDetailsWire.isAgent)">
                <a title="Logout" class="icon-lock" href="{{getLogoutLink()}}">{{
                    "LOG_OUT" | resource
                }}</a>
            </li>
            <li *ngIf="username && userDetailsWire.isAgent">
                <a title="User" class="icon-plus" routerLink="/agent" routerLinkActive="active">{{
                        "START_NEW_RESERVATION" | resource
                    }}
                </a>
            </li>
        </ul>
    </div>
</div>
<div class="help wrapper" *ngIf="!userDetailsWire">
    <div class="row">
        <ul class="column small-12">
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
        </ul>
    </div>
</div>
